import { render, staticRenderFns } from "./RetireTemplate.vue?vue&type=template&id=c04eb63a&"
import script from "./RetireTemplate.vue?vue&type=script&lang=js&"
export * from "./RetireTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports